import {Text} from '@miro-site/core'
import React from 'react'

const Description = (props: {children: React.ReactNode}): React.ReactElement => (
  <Text
    $variant={['p1', 'p0', 'p0', 'p0']}
    $transparency={0.3}
    $styles={{
      maxWidth: [null, 599, 599, 599],
    }}
    $mx="auto"
    $align="center"
  >
    {props.children}
  </Text>
)

export default Description
